interface FrameCounterProps {
    currentFrame: number;
    visible: boolean;
  }
  
  export function FrameCounter({ currentFrame, visible }: FrameCounterProps) {
    return (
      <div className={`frame-counter ${visible ? 'visible' : ''}`}>
        Frame: {currentFrame}
      </div>
    );
  }